<div class="AMSelectModal Container bg-light">
  <div class="fs-52px py-2 px-3">
    {{ title | translate}}
  </div>
  <div class="AMSelectModal_content mt-2 w-100">
    <p class="fs-20px">
      {{ subtitle | translate}}
    </p>
    <div class="d-flex">
      <form [formGroup]="findForm" novalidate class="w-100">
        <div class="d-flex align-items-center " >
          <div class="position-relative ">
            <input
              appAmKeyboard
              [currentFormGroup]="findForm"
              [isFloat]="false"
              [isDarkTheme]="false"
              type="text"
              id="find"
              class="form-control input-control"
              #find
              formControlName="find"
              autocomplete="off"
              [contentKeyboard]= "KeyboardContent"
            >
            <span class="am-clear-button" (click)="clearField()" *ngIf="find.value.length > 0">
                <i class="fa fa-times" aria-hidden="true">
              </i>
            </span>
          </div>
        </div>
      </form>
    </div>
    <p class="fs-20px my-3">
      {{ notice | translate}}
    </p>
    <div class="AMSelectModal_selections" *ngIf="buttons.length > 0">
      <button (click)="onSelected(item)" *ngFor="let item of buttons">
        {{ item[currentLang] }}
      </button>
    </div>
    <div class="AMSelectModal_selections justify-content-center fs-24px text-am-medium-gray" *ngIf="buttons.length === 0 ">
      {{  "modalSelect.noMatchResult" | translate }}
    </div>

  </div>
  <div id="{{KeyboardContent}}">

  </div>

<app-am-footer
[themeDark]="false"
[showContinue]="true"
[showBack]="true"
[textContinue]="'footer.continue'"
[textOnBack]="'goBack'"
(back)="onClose()"
(continue)="onContinue()"
[isDisbaleBack]="isDisabledButton"
></app-am-footer>
</div>
